import { callApiToServer } from '../../callApi';

export async function searchCurrency(
  authToken,
  searchText,
  skipNumber,
  limitNumber
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authToken
    };

    let body = JSON.stringify({
        search_text: searchText,
    });
  
    let endUrl = "v1/filter-currency/" + skipNumber + "/" + limitNumber;
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
  }catch(err) {
    throw err;
  }
}
